import PropertyAnimatedIconContainer from "../../../components/property/detail/PropertyAnimatedIcon";

const PropertyAnimatedIcon = () => {
  return <PropertyAnimatedIconContainer />;
};

export default PropertyAnimatedIcon;
